import { apiConfig } from 'config';
import { fmRequest } from './utils';

export const getAlarmAggregate = (deviceId, fieldName, fromDate, toDate) => {
  const url = apiConfig.fmServiceAlarmAggregate;
  let options = { method: 'POST' };

  let body = {};
  if (deviceId) {
    body.deviceId = deviceId;
  }
  if (fieldName) {
    body.fieldName = fieldName;
  }
  if (fromDate && toDate) {
    body.fromDate = fromDate;
    body.toDate = toDate;
  }

  options.body = JSON.stringify(body);

  return fmRequest(url, options);
};
